import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AppAdmin } from './AppAdmin';
import { i18n } from '@lingui/core';
import { messages } from '../locales/en';
import { I18nProvider } from '@lingui/react';

const root = document.getElementById('root');
if (!root) {
  throw new Error('Root element not found');
}

i18n.load('en', messages);
i18n.activate('en');

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <BrowserRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <I18nProvider i18n={i18n}>
        <AppAdmin />
      </I18nProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
